import React from 'react';
import { Card } from '../common/Card';
import { Link } from 'react-router-dom';
import { CreditCard, Bell, BarChart } from 'lucide-react';

const coreFeatures = [
    {
        icon: CreditCard,
        title: "Track All Subscriptions",
        description: "Easily add and monitor all your subscriptions in one dashboard."
    },
    {
        icon: Bell,
        title: "Smart Reminders",
        description: "Get notified before payments are due to avoid late fees and service interruptions."
    },
    {
        icon: BarChart,
        title: "Spending Analytics",
        description: "Visualize your subscription spending patterns with detailed charts and graphs."
    }
];

export const Features = () => {
    return (
        <section id="features" className="py-20 bg-gray-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-16">
                    <h2 className="text-4xl font-bold text-gray-900 mb-4">
                        Core Features
                    </h2>
                    <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                        Essential tools to help you manage your subscriptions effectively
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
                    {coreFeatures.map((feature, index) => (
                        <Card
                            key={index}
                            className="p-6 hover:shadow-lg transition-shadow duration-300 ease-in-out"
                        >
                            <div className="flex items-center mb-4">
                                <div className="p-2 bg-blue-50 rounded-lg">
                                    <feature.icon className="h-6 w-6 text-blue-500" />
                                </div>
                                <h4 className="text-xl font-semibold ml-3">{feature.title}</h4>
                            </div>
                            <p className="text-gray-600">{feature.description}</p>
                        </Card>
                    ))}
                </div>

                <div className="text-center">
                    <p className="text-gray-600 mb-6">
                        Discover all the powerful features that make KeepItSorted the best choice
                    </p>
                    <Link
                        to="/features"
                        className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 transition duration-150 ease-in-out"
                    >
                        View All Features
                    </Link>
                </div>
            </div>
        </section>
    );
};